import React, { CSSProperties } from 'react'

interface ICircleLoaderProps {
  [key: string]: any
  children?: React.ReactNode
  size?: number
  style?: CSSProperties
  className?: string
}

const CircleLoader = (props: ICircleLoaderProps) => {
  const { children, size, style = {}, className = '', ...otherProps } = props
  const styles = { ...style }
  let cssClass = className

  if (size) {
    styles.width = size + 'px'
    styles.height = size + 'px'
  }
  if (typeof children !== 'undefined') {
    cssClass += ' flex-center'
  }
  return (
    <div className={`circle-loader ${cssClass}`} {...otherProps} style={styles}>
      <div className="circle-main"></div>
      <div className="circle-background"></div>
      {children}
    </div>
  )
}

CircleLoader.defaultProps = {
  className: '',
}

export default React.memo(CircleLoader)
